

/**
 * Campaign grid preview concurrency — facade over ResourceLoadGate (single place to tune max).
 *
 * Slots are held from acquire until LazyVideoPreview fires loadeddata (not until scroll-away).
 * Without early release, only maxConcurrent visible cards ever got src — rest stayed on placeholder.
 */
import { ResourceLoadGate } from '../../../../core/concurrency/ResourceLoadGate';

/** Max simultaneous MP4 decodes; additional visible cards wait and load in sequence. */
const MAX_CONCURRENT_PREVIEW_LOADS = 4;

const campaignPreviewLoadGate = new ResourceLoadGate(MAX_CONCURRENT_PREVIEW_LOADS);

export function acquirePreviewSlot(url) {
  return campaignPreviewLoadGate.acquire(url);
}

export function releasePreviewSlot(url) {
  campaignPreviewLoadGate.release(url);
}

export function resetPreviewLoadGateForTests() {
  campaignPreviewLoadGate.reset();
}

export function resetPreviewLoadGate() {
  campaignPreviewLoadGate.reset();
}

export function getPreviewLoadGateStats() {
  return campaignPreviewLoadGate.getStats();
}
